<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="800" height="600" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="平台登录" :loading="loading">
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="deliverytool"></vxe-grid>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			action: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				currentrow:null,
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {
			//console.log(this.data)
			this.data.forEach((item) => {
				this.getorderinfo(item)
			})
		},
		watch: {

		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 400
				gridOptions.columns = [{
						field: 'code',
						title: '编码',
					},{
						field: 'name',
						title: '名称',
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'login',
								content: '登录',
								status: 'primary',
								inrow: true
							}]
						}
					}
				]
				gridOptions.toolbarConfig.buttons = []
				gridOptions.formConfig = false
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			login(e){
				
				this.currentrow = e
				this.$confirm('是否确认登录', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.tool.externalLogin({id:e.id}).then((res)=>{
						if(res==1){
							this.$message.success('登录成功')
						}else{
							this.$message.error('登录失败')
						}
						
						this.loading = false
					},()=>{
						this.loading = false
					})
				}).catch(() => {
	
				})
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: [{
							id:'ERP',
							code:'ERP',
							name:'万里牛ERP'
						},
						{
							id:'WMS',
							code:'WMS',
							name:'万里牛WMS'
						},
						{
							id:'MES',
							code:'MES',
							name:'纳极智MES'
						},
						{
							id:'XW',
							code:'XW',
							name:'小望'
						},
						{
							id:'YQDZ',
							code:'YQDZ',
							name:'亿企赢'
						}
						]
					})
				})
			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
		},
		components: {

		}
	}
</script>